import { render } from "./PDetails3.vue?vue&type=template&id=287e36b8&scoped=true"
import script from "./PDetails3.vue?vue&type=script&lang=js"
export * from "./PDetails3.vue?vue&type=script&lang=js"

import "./PDetails3.vue?vue&type=style&index=0&id=287e36b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287e36b8"]])

export default __exports__